import customValidator from '../validators/customValidator';

const personalInformationModel = () => {
  return {
    sections: [
      {
        title: 'Team Members',
        rows: [

          {
            cols:
              [
                {
                  label: 'Legal Representative Information',
                  type: 'label',
                },
              ],
          },
          {
            cols:
              [
                {
                  label: 'Legal Status',
                  mapTo: 'legalStatusId',
                  required: false,
                  isInvalid: false,
                  style: {},
                  optionType: 'LegalStatus',
                  type: 'radio',
                  inline: true,
                },
              ],
          },
          {
            cols:
              [
                {
                  label: 'Legal Representative:',
                  type: 'label',
                  style: {
                    width: '300px',
                  },
                },
                {
                  label: 'Legal Representative:',
                  type: 'label',
                  style: {
                    width: '300px',
                  },
                },
              ],
          },
          {
            cols:
              [
                {
                  rows: [
                    {
                      cols: [
                        {
                          label: 'First Name',
                          mapTo: 'teamMembers[0].firstName',
                          required: false,
                          isInvalid: false,
                          maxLength: 20,
                          style: {
                            width: '300px',
                          },
                          validation: (section, currentColumn, constructedData, currentColumnValue, errors) => {
                            let data = constructedData.teamMembers ? constructedData.teamMembers[0] : null;
                            return customValidator.validateDependantRequiredColumn(
                              'Legal Representative',
                              'First Name',
                              currentColumn,
                              currentColumnValue,
                              data,
                              (data) => 
                                data.lastName ||
                                data.address ||
                                data.city ||
                                data.state ||
                                data.zipCode ||
                                data.workPhoneNumber ||
                                data.email,
                              errors);
                          }
                        }
                      ]
                    },
                    {
                      cols: [
                        {
                          label: 'Last Name',
                          mapTo: 'teamMembers[0].lastName',
                          required: false,
                          isInvalid: false,
                          maxLength: 20,
                          style: {
                            width: '300px',
                          },
                          validation: (section, currentColumn, constructedData, currentColumnValue, errors) => {
                            let data = constructedData.teamMembers ? constructedData.teamMembers[0] : null;
                            return customValidator.validateDependantRequiredColumn(
                              'Legal Representative',
                              'Last Name',
                              currentColumn,
                              currentColumnValue,
                              data,
                              (data) => 
                                data.firstName ||
                                data.address ||
                                data.city ||
                                data.state ||
                                data.zipCode ||
                                data.workPhoneNumber ||
                                data.email,
                              errors);
                          }
                        }
                      ]
                    },
                    {
                      cols: [
                        {
                          label: 'Address',
                          mapTo: 'teamMembers[0].address',
                          required: false,
                          isInvalid: false,
                          maxLength: 100,
                          style: {
                            width: '300px',
                          },
                        }
                      ]
                    },
                    {
                      cols: [
                        {
                          label: 'City',
                          mapTo: 'teamMembers[0].city',
                          required: false,
                          isInvalid: false,
                          maxLength: 40,
                          style: {
                            width: '300px',
                          },
                        }
                      ]
                    },
                    {
                      cols: [
                        {
                          label: 'State',
                          mapTo: 'teamMembers[0].state',
                          required: false,
                          isInvalid: false,
                          maxLength: 2,
                          style: {
                            width: '300px',
                          },
                        }
                      ]
                    },
                    {
                      cols: [
                        {
                          label: 'Zip Code',
                          mapTo: 'teamMembers[0].zipCode',
                          required: false,
                          isInvalid: false,
                          maxLength: 10,
                          style: {
                            width: '300px',
                          },
                        }
                      ]
                    },
                    {
                      cols: [
                        {
                          label: 'Work Phone Number',
                          mapTo: 'teamMembers[0].workPhoneNumber',
                          type: 'tel',
                          required: false,
                          isInvalid: false,
                          isPhoneNumber: true,
                          maxLength: 30,
                          style: {
                            width: '300px',
                          },
                        }
                      ]
                    },
                    {
                      cols: [
                        {
                          label: 'E-mail',
                          mapTo: 'teamMembers[0].email',
                          type: 'text',
                          required: false,
                          isInvalid: false,
                          isEmail: true,
                          maxLength: 200,
                          style: {
                            width: '300px',
                          },
                        }
                      ]
                    },
                    
                    {
                      cols: [
                        {
                          type: 'singleCheckbox',
                          label: 'Is an Emergency Contact',
                          mapTo: 'teamMembers[0].isEmergencyContact',
                          onChange: (data, currentValue) => {
                            
                          }
                        }
                      ]
                    },
                    {
                      cols: [
                        {
                          type: 'singleCheckbox',
                          label: 'Is Family/Other Team Member',
                          mapTo: 'teamMembers[0].isOtherTeamMember',
                        },
                      ]
                    },
                  ]
                },
                {
                  rows: [
                    {
                      cols: [
                        {
                          label: 'First Name',
                          mapTo: 'teamMembers[1].firstName',
                          required: false,
                          isInvalid: false,
                          maxLength: 20,
                          style: {
                            width: '300px',
                          },
                          validation: (section, currentColumn, constructedData, currentColumnValue, errors) => {
                            let data = constructedData.teamMembers ? constructedData.teamMembers[1] : null;
                            return customValidator.validateDependantRequiredColumn(
                              'Legal Representative',
                              'First Name',
                              currentColumn,
                              currentColumnValue,
                              data,
                              (data) => 
                                data.lastName ||
                                data.address ||
                                data.city ||
                                data.state ||
                                data.zipCode ||
                                data.workPhoneNumber ||
                                data.email,
                              errors);
                          }
                        }
                      ]
                    },
                    {
                      cols: [
                        {
                          label: 'Last Name',
                          mapTo: 'teamMembers[1].lastName',
                          required: false,
                          isInvalid: false,
                          maxLength: 20,
                          style: {
                            width: '300px',
                          },
                          validation: (section, currentColumn, constructedData, currentColumnValue, errors) => {
                            let data = constructedData.teamMembers ? constructedData.teamMembers[1] : null;
                            return customValidator.validateDependantRequiredColumn(
                              'Legal Representative',
                              'Last Name',
                              currentColumn,
                              currentColumnValue,
                              data,
                              (data) => 
                                data.firstName ||
                                data.address ||
                                data.city ||
                                data.state ||
                                data.zipCode ||
                                data.workPhoneNumber ||
                                data.email,
                              errors);
                          }
                        }
                      ]
                    },
                    {
                      cols: [
                        {
                          label: 'Address',
                          mapTo: 'teamMembers[1].address',
                          required: false,
                          isInvalid: false,
                          maxLength: 100,
                          style: {
                            width: '300px',
                          },
                        },
                      ],
                    },
                    {
                      cols: [
                        {
                          label: 'City',
                          mapTo: 'teamMembers[1].city',
                          required: false,
                          isInvalid: false,
                          maxLength: 40,
                          style: {
                            width: '300px',
                          },
                        }
                      ]
                    },
                    {
                      cols: [
                        {
                          label: 'State',
                          mapTo: 'teamMembers[1].state',
                          required: false,
                          isInvalid: false,
                          maxLength: 2,
                          style: {
                            width: '300px',
                          },
                        }
                      ]
                    },
                    {
                      cols: [
                        {
                          label: 'Zip Code',
                          mapTo: 'teamMembers[1].zipCode',
                          required: false,
                          isInvalid: false,
                          maxLength: 10,
                          style: {
                            width: '300px',
                          },
                        }
                      ]
                    },
                    {
                      cols: [
                        {
                          label: 'Work Phone Number',
                          mapTo: 'teamMembers[1].workPhoneNumber',
                          type: 'tel',
                          required: false,
                          isInvalid: false,
                          isPhoneNumber: true,
                          maxLength: 30,
                          style: {
                            width: '300px',
                          },
                        },
                      ],
                    },
                    {
                      cols: [
                        {
                          label: 'E-mail',
                          mapTo: 'teamMembers[1].email',
                          type: 'text',
                          required: false,
                          isInvalid: false,
                          isEmail: true,
                          maxLength: 200,
                          style: {
                            width: '300px',
                          },
                        },
                      ],
                    },

                    {
                      cols: [
                        {
                          type: 'singleCheckbox',
                          label: 'Is an Emergency Contact',
                          mapTo: 'teamMembers[1].isEmergencyContact',
                        }
                      ]
                    },
                    {
                      cols: [
                        {
                          type: 'singleCheckbox',
                          label: 'Is Family/Other Team Member',
                          mapTo: 'teamMembers[1].isOtherTeamMember',
                        },
                      ]
                    },
                  ]
                },
              ],
          },
        ],
      },
      {
        title: 'Residential Information',
        style: {
          marginTop: '15px',
        },
        rows: [
          {
            cols: [
              {
                sections: [
                  {
                    rows: [
                      {
                        cols: [
                          {
                            label: 'Living Arrangement:',
                            type: 'label',
                          }
                        ]
                      },
                      {
                        cols: [
                          {
                            label:
                              'Check the box of your current living arrangement',
                            mapTo: 'livingArrangementId',
                            validation: '',
                            required: false,
                            optionType: 'ResidentialLivingArrangement',
                            isInvalid: false,
                            type: 'radio',
                            includeOther: true,
                            otherMapTo: 'livingArrangementOther',
                            maxLength: 50,
                            otherTextStyle: {
                              marginLeft: '20px'
                            }
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                sections: [
                  {
                    title: '',
                    className: 'left-border',
                    rows: [
                      {
                        cols: [
                          {
                            label: 'Residential Provider',
                            type: 'label'
                          }
                        ]
                      },
                      {
                        cols: [
                          {
                            label: 'Company Name',
                            mapTo: 'contacts[0].name',
                            type: 'text',
                            style: {
                              width: '230px',
                            },
                            validation: (section, currentColumn, constructedData, currentColumnValue, errors) => {
                              let data = constructedData.contacts ? constructedData.contacts[0] : null;
                              return customValidator.validateDependantRequiredColumn(
                                'Residential Provider',
                                'Company Name',
                                currentColumn,
                                currentColumnValue,
                                data,
                                (data) =>
                                  data.address ||
                                  data.city ||
                                  data.state ||
                                  data.zipCode ||
                                  data.workPhoneNumber ||
                                  data.cellPhoneNumber
                                ,
                                errors);
                            }
                          },
                          {
                            label: 'Address',
                            mapTo: 'contacts[0].address',
                            type: 'text',
                            style: {
                              width: '330px',
                            },
                          },
                        ],
                      },
                      {
                        cols: [
                          {
                            label: 'City',
                            mapTo: 'contacts[0].city',
                            type: 'text',
                            maxLength: 40,
                            style: {
                              width: '230px',
                            },
                          },
                          {
                            label: 'State',
                            mapTo: 'contacts[0].state',
                            type: 'text',
                            maxLength: 2,
                            style: {
                              width: '100px',
                            },
                          },
                          {
                            label: 'Zip Code',
                            mapTo: 'contacts[0].zipCode',
                            type: 'text',
                            maxLength: 10,
                            style: {
                              width: '100px',
                            },
                          },
                        ],
                      },
                      {
                        cols: [
                          {
                            label: 'Work Phone Number',
                            mapTo: 'contacts[0].workPhoneNumber',
                            type: 'tel',
                            required: false,
                            isInvalid: false,
                            isPhoneNumber: true,
                            maxLength: 30,
                            style: {
                              width: '230px',
                            },
                          },
                          {
                            label: 'Cell Phone Number',
                            mapTo: 'contacts[0].cellPhoneNumber',
                            type: 'tel',
                            required: false,
                            isInvalid: false,
                            isPhoneNumber: true,
                            maxLength: 30,
                            style: {
                              width: '230px',
                            },
                          },
                        ],
                      },
                      {
                        cols: [
                          {
                            label: 'Residential Contacts',
                            type: 'label',
                            style: {
                              width: '230px',
                            },
                          },
                        ],
                      },
                      {
                        cols: [
                          {
                            rows: [
                              {
                                cols: [
                                  {
                                    label: 'First Name',
                                    mapTo: 'contacts[1].firstName',
                                    maxLength: 20,
                                    type: 'text',
                                    style: {
                                      width: '230px',
                                    },
                                    validation: (section, currentColumn, constructedData, currentColumnValue, errors) => {
                                      let data = constructedData.contacts ? constructedData.contacts[1] : null;
                                      return customValidator.validateDependantRequiredColumn(
                                        'Residential Contacts',
                                        'First Name',
                                        currentColumn,
                                        currentColumnValue,
                                        data,
                                        (data) =>
                                          data.lastName ||
                                          data.title ||
                                          data.workPhoneNumber ||
                                          data.email
                                          ,
                                        errors);
                                    }
                                  },
                                ]
                              },
                              {
                                cols: [
                                  {
                                    label: 'Last Name',
                                    mapTo: 'contacts[1].lastName',
                                    maxLength: 20,
                                    type: 'text',
                                    style: {
                                      width: '230px',
                                    },
                                    validation: (section, currentColumn, constructedData, currentColumnValue, errors) => {
                                      let data = constructedData.contacts ? constructedData.contacts[1] : null;
                                      return customValidator.validateDependantRequiredColumn(
                                        'Residential Contacts',
                                        'Last Name',
                                        currentColumn,
                                        currentColumnValue,
                                        data,
                                        (data) =>
                                          data.firstName ||
                                          data.title ||
                                          data.workPhoneNumber ||
                                          data.email
                                          ,
                                        errors);
                                    }
                                  },
                                ]
                              },
                              {
                                cols: [
                                  {
                                    label: 'Title',
                                    mapTo: 'contacts[1].title',
                                    type: 'text',
                                    maxLength: 20,
                                    style: {
                                      width: '230px',
                                    },
                                  },
                                ]
                              },
                              {
                                cols: [
                                  {
                                    label: 'Work Phone Number',
                                    mapTo: 'contacts[1].workPhoneNumber',
                                    type: 'tel',
                                    required: false,
                                    isInvalid: false,
                                    isPhoneNumber: true,
                                    maxLength: 30,
                                    style: {
                                      width: '230px',
                                    },
                                  },
                                ]
                              },
                              {
                                cols: [
                                  {
                                    label: 'E-mail',
                                    mapTo: 'contacts[1].email',
                                    type: 'text',
                                    required: false,
                                    isInvalid: false,
                                    isEmail: true,
                                    maxLength: 200,
                                    style: {
                                      width: '230px',
                                    },
                                  },
                                ]
                              }
                            ]
                          },
                          {
                            rows: [
                              {
                                cols: [
                                  {
                                    label: 'First Name',
                                    mapTo: 'contacts[2].firstName',
                                    maxLength: 20,
                                    type: 'text',
                                    style: {
                                      width: '230px',
                                    },
                                    validation: (section, currentColumn, constructedData, currentColumnValue, errors) => {
                                      let data = constructedData.contacts ? constructedData.contacts[2] : null;
                                      return customValidator.validateDependantRequiredColumn(
                                        'Residential Contacts',
                                        'First Name',
                                        currentColumn,
                                        currentColumnValue,
                                        data,
                                        (data) =>
                                          data.lastName ||
                                          data.title ||
                                          data.workPhoneNumber ||
                                          data.email
                                          ,
                                        errors);
                                    }
                                  },
                                ]
                              },
                              {
                                cols: [
                                  {
                                    label: 'Last Name',
                                    mapTo: 'contacts[2].lastName',
                                    maxLength: 20,
                                    type: 'text',
                                    style: {
                                      width: '230px',
                                    },
                                    validation: (section, currentColumn, constructedData, currentColumnValue, errors) => {
                                      let data = constructedData.contacts ? constructedData.contacts[2] : null;
                                      return customValidator.validateDependantRequiredColumn(
                                        'Residential Contacts',
                                        'Last Name',
                                        currentColumn,
                                        currentColumnValue,
                                        data,
                                        (data) =>
                                          data.firstName ||
                                          data.title ||
                                          data.workPhoneNumber ||
                                          data.email
                                          ,
                                        errors);
                                    }
                                  },
                                ]
                              },
                              {
                                cols: [
                                  {
                                    label: 'Title',
                                    mapTo: 'contacts[2].title',
                                    type: 'text',
                                    maxLength: 20,
                                    style: {
                                      width: '230px',
                                    }
                                  },
                                ]
                              },
                              {
                                cols: [
                                  {
                                    label: 'Work Phone Number',
                                    mapTo: 'contacts[2].workPhoneNumber',
                                    type: 'tel',
                                    required: false,
                                    isInvalid: false,
                                    isPhoneNumber: true,
                                    maxLength: 30,
                                    style: {
                                      width: '230px',
                                    }
                                  },
                                ],
                              },
                              {
                                cols: [
                                  {
                                    label: 'E-mail',
                                    mapTo: 'contacts[2].email',
                                    type: 'text',
                                    required: false,
                                    isInvalid: false,
                                    isEmail: true,
                                    maxLength: 200,
                                    style: {
                                      width: '230px',
                                    },
                                  },
                                ],
                              },
                            ]
                          }
                        ],
                      }
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        title: 'Case Manager/Counselor Contact Information',
        rows: [
          {
            cols: [
              {
                label: 'First Name',
                type: 'text',
                mapTo: 'caseManagers[0].firstName',
                maxLength: 20,
                style: {
                  width: '230px',
                },
                validation: (section, currentColumn, constructedData, currentColumnValue, errors) => {
                  let data = constructedData.caseManagers ? constructedData.caseManagers[0] : null;
                  return customValidator.validateDependantRequiredColumn(
                    'Case Manager/Counselor Contact Information',
                    'First Name',
                    currentColumn,
                    currentColumnValue,
                    data,
                    (data) =>
                      data.lastName ||
                      data.agency ||
                      data.address ||
                      data.city ||
                      data.state ||
                      data.zipCode ||
                      data.email ||
                      data.cellPhoneNumber ||
                      data.workPhoneNumber
                    ,
                    errors);
                }
              },
              {
                label: 'Last Name',
                type: 'text',
                mapTo: 'caseManagers[0].lastName',
                maxLength: 20,
                style: {
                  width: '230px',
                },
                validation: (section, currentColumn, constructedData, currentColumnValue, errors) => {
                  let data = constructedData.caseManagers ? constructedData.caseManagers[0] : null;
                  return customValidator.validateDependantRequiredColumn(
                    'Case Manager/Counselor Contact Information',
                    'Last Name',
                    currentColumn,
                    currentColumnValue,
                    data,
                    (data) =>
                      data.firstName ||
                      data.agency ||
                      data.address ||
                      data.city ||
                      data.state ||
                      data.zipCode ||
                      data.email ||
                      data.cellPhoneNumber ||
                      data.workPhoneNumber
                    ,
                    errors);
                }
              },
              {
                label: 'Agency',
                mapTo: 'caseManagers[0].agency',
                type: 'text',
                maxLength: 50,
                style: {
                  width: '230px',
                },
              },
            ],
          },
          {
            cols: [
              {
                label: 'Address',
                mapTo: 'caseManagers[0].address',
                type: 'text',
                style: {
                  width: '330px',
                },
              },
            ]
          },
          {
            cols: [
              {
                label: 'City',
                mapTo: 'caseManagers[0].city',
                type: 'text',
                maxLength: 40,
                style: {
                  width: '230px',
                },
              },
              {
                label: 'State',
                mapTo: 'caseManagers[0].state',
                type: 'text',
                maxLength: 2,
                style: {
                  width: '230px',
                },
              },
              {
                label: 'Zip Code',
                mapTo: 'caseManagers[0].zipCode',
                type: 'text',
                maxLength: 10,
                style: {
                  width: '230px',
                },
              }
            ],
          },
          {
            cols: [
              {
                label: 'E-mail',
                mapTo: 'caseManagers[0].email',
                type: 'text',
                required: false,
                isInvalid: false,
                isEmail: true,
                maxLength: 200,
                style: {
                  width: '230px',
                },
              },
              {
                label: 'Cell Phone Number',
                mapTo: 'caseManagers[0].cellPhoneNumber',
                type: 'tel',
                required: false,
                isInvalid: false,
                isPhoneNumber: true,
                maxLength: 30,
                style: {
                  width: '230px',
                },
              },
              {
                label: 'Work Phone Number',
                mapTo: 'caseManagers[0].workPhoneNumber',
                type: 'tel',
                required: false,
                isInvalid: false,
                isPhoneNumber: true,
                maxLength: 30,
                style: {
                  width: '230px',
                },
              },
            ],
          },
        ],
      },
      {
        title: 'Case Manager/Counselor Contact Information',
        rows: [
          {
            cols: [
              {
                label: 'First Name',
                type: 'text',
                mapTo: 'caseManagers[1].firstName',
                maxLength: 20,
                style: {
                  width: '230px',
                },
                validation: (section, currentColumn, constructedData, currentColumnValue, errors) => {
                  let data = constructedData.caseManagers ? constructedData.caseManagers[1] : null;
                  return customValidator.validateDependantRequiredColumn(
                    'Case Manager/Counselor Contact Information',
                    'First Name',
                    currentColumn,
                    currentColumnValue,
                    data,
                    (data) =>
                      data.lastName ||
                      data.agency ||
                      data.address ||
                      data.city ||
                      data.state ||
                      data.zipCode ||
                      data.email ||
                      data.cellPhoneNumber ||
                      data.workPhoneNumber
                    ,
                    errors);
                }
              },
              {
                label: 'Last Name',
                type: 'text',
                mapTo: 'caseManagers[1].lastName',
                maxLength: 20,
                style: {
                  width: '230px',
                },
                validation: (section, currentColumn, constructedData, currentColumnValue, errors) => {
                  let data = constructedData.caseManagers ? constructedData.caseManagers[1] : null;
                  return customValidator.validateDependantRequiredColumn(
                    'Case Manager/Counselor Contact Information',
                    'Last Name',
                    currentColumn,
                    currentColumnValue,
                    data,
                    (data) =>
                      data.firstName ||
                      data.agency ||
                      data.address ||
                      data.city ||
                      data.state ||
                      data.zipCode ||
                      data.email ||
                      data.cellPhoneNumber ||
                      data.workPhoneNumber
                    ,
                    errors);
                }
              },
              {
                label: 'Agency',
                mapTo: 'caseManagers[1].agency',
                type: 'text',
                maxLength: 50,
                style: {
                  width: '230px',
                },
              },
            ],
          },
          {
            cols: [
              {
                label: 'Address',
                mapTo: 'caseManagers[1].address',
                type: 'text',
                style: {
                  width: '330px',
                },
              },
            ]
          },
          {
            cols: [
              {
                label: 'City',
                mapTo: 'caseManagers[1].city',
                type: 'text',
                maxLength: 40,
                style: {
                  width: '230px',
                },
              },
              {
                label: 'State',
                mapTo: 'caseManagers[1].state',
                type: 'text',
                maxLength: 2,
                style: {
                  width: '230px',
                },
              },
              {
                label: 'Zip Code',
                mapTo: 'caseManagers[1].zipCode',
                type: 'text',
                maxLength: 10,
                style: {
                  width: '230px',
                },
              }
            ],
          },
          {
            cols: [
              {
                label: 'E-mail',
                mapTo: 'caseManagers[1].email',
                type: 'text',
                required: false,
                isInvalid: false,
                isEmail: true,
                maxLength: 200,
                style: {
                  width: '230px',
                },
              },
              {
                label: 'Cell Phone Number',
                mapTo: 'caseManagers[1].cellPhoneNumber',
                type: 'tel',
                required: false,
                isInvalid: false,
                isPhoneNumber: true,
                maxLength: 30,
                style: {
                  width: '230px',
                },
              },
              {
                label: 'Work Phone Number',
                mapTo: 'caseManagers[1].workPhoneNumber',
                type: 'tel',
                required: false,
                isInvalid: false,
                isPhoneNumber: true,
                maxLength: 30,
                style: {
                  width: '230px',
                },
              },
            ],
          },
        ],
      },
      {
        title: 'Family/Other Team Members',
        rows: [
          {
            cols: [
              {
                type: 'label',
                label: '*Information copied from Legal Representative',
                style: {
                  color: 'black'
                },
                isVisible : (data) =>{
                  return  data.teamMembers[0] && data.teamMembers[0].isOtherTeamMember === true;
                }
              }
            ]
          },
          {
            cols: [
              {
                label: 'First Name',
                mapTo: 'teamMembers[2].firstName',
                type: 'text',
                maxLength: 20,
                style: {
                  width: '230px',
                },
                validation: (section, currentColumn, constructedData, currentColumnValue, errors) => {
                  let data = constructedData.teamMembers ? constructedData.teamMembers[2] : null;
                  return customValidator.validateDependantRequiredColumn(
                    'Family/Other Team Members',
                    'First Name',
                    currentColumn,
                    currentColumnValue,
                    data,
                    (data) =>
                      data.lastName||
                      data.relationshipToClient||
                      data.address ||
                      data.city ||
                      data.state ||
                      data.zipCode ||
                      data.cellPhoneNumber ||
                      data.workPhoneNumber ||
                      data.email
                      ,
                    errors);
                },
                isDisabled : (data) => {
                  return data.teamMembers[0] && data.teamMembers[0].isOtherTeamMember;
                },
                specialAsteriksVisibility: (data) => {
                  return data.teamMembers[0] && data.teamMembers[0].isOtherTeamMember;
                }
              },
              {
                label: 'Last Name',
                mapTo: 'teamMembers[2].lastName',
                type: 'text',
                maxLength: 20,
                style: {
                  width: '230px',
                },
                validation: (section, currentColumn, constructedData, currentColumnValue, errors) => {
                  let data = constructedData.teamMembers ? constructedData.teamMembers[2] : null;
                  return customValidator.validateDependantRequiredColumn(
                    'Family/Other Team Members',
                    'Last Name',
                    currentColumn,
                    currentColumnValue,
                    data,
                    (data) =>
                      data.firstName||
                      data.relationshipToClient||
                      data.address ||
                      data.city ||
                      data.state ||
                      data.zipCode ||
                      data.cellPhoneNumber ||
                      data.workPhoneNumber ||
                      data.email
                      ,
                    errors);
                },
                isDisabled : (data) => {
                  return data && data.teamMembers[0] && data.teamMembers[0].isOtherTeamMember;
                },
                specialAsteriksVisibility: (data) => {
                  return data && data.teamMembers[0] && data.teamMembers[0].isOtherTeamMember;
                },
              },
              {
                label: 'Relationship to Client',
                mapTo: 'teamMembers[2].relationshipToClient',
                type: 'text',
                maxLength: 50,
                style: {
                  width: '230px',
                },
              },
            ],
          },
          {
            cols: [
              {
                label: 'Address',
                mapTo: 'teamMembers[2].address',
                type: 'text',
                style: {
                  width: '330px',
                },
              },
            ]
          },
          {
            cols: [
              {
                label: 'City',
                mapTo: 'teamMembers[2].city',
                type: 'text',
                maxLength: 40,
                style: {
                  width: '230px',
                },
              },
              {
                label: 'State',
                mapTo: 'teamMembers[2].state',
                type: 'text',
                maxLength: 2,
                style: {
                  width: '230px',
                },
              },
              {
                label: 'Zip Code',
                mapTo: 'teamMembers[2].zipCode',
                type: 'text',
                maxLength: 10,
                style: {
                  width: '230px',
                },
              }
            ],
          },
          {
            cols: [
              {
                label: 'Cell Phone Number',
                mapTo: 'teamMembers[2].cellPhoneNumber',
                type: 'tel',
                required: false,
                isInvalid: false,
                isPhoneNumber: true,
                maxLength: 30,
                style: {
                  width: '230px',
                },
              },
              {
                label: 'Work Phone Number',
                mapTo: 'teamMembers[2].workPhoneNumber',
                type: 'tel',
                required: false,
                isInvalid: false,
                isPhoneNumber: true,
                maxLength: 30,
                style: {
                  width: '230px',
                },
                specialAsteriksVisibility: (data) => {
                  return data && data.teamMembers[0] && data.teamMembers[0].isOtherTeamMember;
                },
                isDisabled : (data) => {
                  return data && data.teamMembers[0] && data.teamMembers[0].isOtherTeamMember;
                }
              },
              {
                label: 'E-mail',
                mapTo: 'teamMembers[2].email',
                type: 'text',
                required: false,
                isInvalid: false,
                isEmail: true,
                maxLength: 200,
                style: {
                  width: '230px',
                },
                specialAsteriksVisibility: (data) => {
                  return data.teamMembers[0] && data.teamMembers[0].isOtherTeamMember;
                },
                isDisabled : (data) => {
                  return data.teamMembers[0] && data.teamMembers[0].isOtherTeamMember;
                }
              },
            ],
          },
        ],
      },
      {
        title: 'Family/Other Team Members',
        rows: [
          {
            cols: [
              {
                type: 'label',
                label: '*Information copied from Legal Representative',
                style: {
                  color: 'black'
                },
                isVisible : (data) =>{
                  return data.teamMembers[1] && data.teamMembers[1].isOtherTeamMember;
                }
              }
            ]
          },
          {
            cols: [
              {
                label: 'First Name',
                mapTo: 'teamMembers[3].firstName',
                type: 'text',
                maxLength: 20,
                style: {
                  width: '230px',
                },
                validation: (section, currentColumn, constructedData, currentColumnValue, errors) => {
                  let data = constructedData.teamMembers ? constructedData.teamMembers[3] : null;
                  return customValidator.validateDependantRequiredColumn(
                    'Family/Other Team Members',
                    'First Name',
                    currentColumn,
                    currentColumnValue,
                    data,
                    (data) =>
                      data.lastName||
                      data.relationshipToClient||
                      data.address ||
                      data.city ||
                      data.state ||
                      data.zipCode ||
                      data.cellPhoneNumber ||
                      data.workPhoneNumber ||
                      data.email
                      ,
                    errors);
                },
                isDisabled : (data) => {
                  return data.teamMembers[1] && data.teamMembers[1].isOtherTeamMember;
                },
                specialAsteriksVisibility: (data) => {
                  return data.teamMembers[1] && data.teamMembers[1].isOtherTeamMember;
                }
              },
              {
                label: 'Last Name',
                mapTo: 'teamMembers[3].lastName',
                type: 'text',
                maxLength: 20,
                style: {
                  width: '230px',
                },
                validation: (section, currentColumn, constructedData, currentColumnValue, errors) => {
                  let data = constructedData.teamMembers ? constructedData.teamMembers[3] : null;
                  return customValidator.validateDependantRequiredColumn(
                    'Family/Other Team Members',
                    'Last Name',
                    currentColumn,
                    currentColumnValue,
                    data,
                    (data) =>
                      data.firstName||
                      data.relationshipToClient||
                      data.address ||
                      data.city ||
                      data.state ||
                      data.zipCode ||
                      data.cellPhoneNumber ||
                      data.workPhoneNumber ||
                      data.email
                      ,
                    errors);
                },
                isDisabled : (data) => {
                  return data.teamMembers[1] && data.teamMembers[1].isOtherTeamMember;
                },
                specialAsteriksVisibility: (data) => {
                  return data.teamMembers[1] && data.teamMembers[1].isOtherTeamMember;
                }
              },
              {
                label: 'Relationship to Client',
                mapTo: 'teamMembers[3].relationshipToClient',
                type: 'text',
                maxLength: 50,
                style: {
                  width: '230px',
                },
              },
            ],
          },
          {
            cols: [
              {
                label: 'Address',
                mapTo: 'teamMembers[3].address',
                type: 'text',
                style: {
                  width: '330px',
                },
              },
            ]
          },
          {
            cols: [
              {
                label: 'City',
                mapTo: 'teamMembers[3].city',
                type: 'text',
                maxLength: 40,
                style: {
                  width: '230px',
                },
              },
              {
                label: 'State',
                mapTo: 'teamMembers[3].state',
                type: 'text',
                maxLength: 2,
                style: {
                  width: '230px',
                },
              },
              {
                label: 'Zip Code',
                mapTo: 'teamMembers[3].zipCode',
                type: 'text',
                maxLength: 10,
                style: {
                  width: '230px',
                },
              }
            ],
          },
          {
            cols: [
              {
                label: 'Cell Phone Number',
                mapTo: 'teamMembers[3].cellPhoneNumber',
                type: 'tel',
                required: false,
                isInvalid: false,
                isPhoneNumber: true,
                maxLength: 30,
                style: {
                  width: '230px',
                },
              },
              {
                label: 'Work Phone Number',
                mapTo: 'teamMembers[3].workPhoneNumber',
                type: 'tel',
                required: false,
                isInvalid: false,
                isPhoneNumber: true,
                maxLength: 30,
                style: {
                  width: '230px',
                },
                isDisabled : (data) => {
                  return data.teamMembers[1] && data.teamMembers[1].isOtherTeamMember;
                },
                specialAsteriksVisibility: (data) => {
                  return data.teamMembers[1] && data.teamMembers[1].isOtherTeamMember;
                }
              },
              {
                label: 'E-mail',
                mapTo: 'teamMembers[3].email',
                type: 'text',
                required: false,
                isInvalid: false,
                isEmail: true,
                maxLength: 200,
                style: {
                  width: '230px',
                },
                isDisabled : (data) => {
                  return data.teamMembers[1] && data.teamMembers[1].isOtherTeamMember;
                },
                specialAsteriksVisibility: (data) => {
                  return data.teamMembers[1] && data.teamMembers[1].isOtherTeamMember;
                }
              },
            ],
          },
        ],
      },
    ],
  };
};

export default personalInformationModel;
